import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=335812c8"
import script from "./addInfo.vue?vue&type=script&lang=js"
export * from "./addInfo.vue?vue&type=script&lang=js"
import style0 from "./addInfo.vue?vue&type=style&index=0&id=335812c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports